export default "__VITE_ASSET__BMGbsMCu__"